import axiosInstance from '../../../../config/axiosInstance';
const  FormService = {
    async GetAllForms(redirectCallback) {
        try {            
            const ClientID = localStorage.getItem('CompanyID');
            const RoleID = localStorage.getItem('RoleID');
            const response = await axiosInstance.get(`/Setup/GetAllForms?ClientID=${ClientID}&RoleID=${RoleID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetAllFormsByModuleID(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Setup/GetFormsByModuleID?ModuleID=${ID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetClientAssignedForms(redirectCallback,ClientID,ModuleID) {
        try {           
            const response = await axiosInstance.get(`/Setup/GetClientAssignedForms?ClientID=${ClientID}&ModuleID=${ModuleID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    },
    async GetAllFormsWihClient(redirectCallback,ClientID,RoleID) {
        try {            
            const response = await axiosInstance.get(`/Setup/GetAllFormsWihClient?ClientID=${ClientID}&RoleID=${RoleID}`);
            return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching roles:', error);
            throw error;
        }
    }
};

export default FormService;